/**
 * The session gate's decision, apart from the hook, so bun can test it:
 * `use-session-status.ts` reaches the Better Auth Expo client, which bun
 * cannot load.
 */

/**
 * `unconfirmed` is the wait running out with no session in hand and the
 * request still in flight. The gate draws sign-in for it, exactly as before.
 * It is NOT `signed-out`, and the difference is the whole device: `MeProvider`
 * wipes every table on `signed-out`, the outbox of unsent entries included.
 * A phone busy at launch with lakhs of rows can take longer than the wait to
 * hand over its cached session, and that wiped a signed-in phone and sent it
 * back to a first download of everything.
 */
export type SessionStatus = 'loading' | 'unconfirmed' | 'signed-out' | 'signed-in';

/** The decision, pure, so a test can hold it. */
export const sessionStatusOf = (input: {
  readonly hasSession: boolean;
  readonly isPending: boolean;
  readonly waitedLongEnough: boolean;
}): SessionStatus => {
  if (input.hasSession) return 'signed-in';
  if (!input.isPending) return 'signed-out';
  return input.waitedLongEnough ? 'unconfirmed' : 'loading';
};
